import { Translation, TranslationObject } from './translation';
import commonTranslations from './commonTranslations.i18n';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getTranslationsForKeyInFile = (
  objectInPath: any,
  key: string,
): Translation[] => {
  const translations: Translation[] = [];
  const element = objectInPath[key];
  if (typeof element.default != 'undefined') {
    const bundle = element.default;
    for (const translation in bundle) {
      if (bundle.hasOwnProperty(translation)) {
        translations.push(bundle[translation]);
      }
    }
    return translations;
  }

  for (const k in element) {
    if (element.hasOwnProperty(k)) {
      translations.push(...getTranslationsForKeyInFile(element, k));
    }
  }

  return translations;
};

export const formatTranslationFiles = (
  translationObjects: TranslationObject[],
): Translation[] => {
  const translationsFromFiles: Translation[] = [];
  for (const key in translationObjects) {
    if (translationObjects.hasOwnProperty(key)) {
      translationsFromFiles.push(
        ...getTranslationsForKeyInFile(translationObjects, key),
      );
    }
  }

  return translationsFromFiles;
};

export const getTranslationsFromFiles = (): Translation[] => {
  const translationsFiles: TranslationObject[] = require('../**/*.i18n.ts');
  const translationsFromFiles = formatTranslationFiles(translationsFiles);

  return [...translationsFromFiles, ...commonTranslations];
};
